import Tier from "./Tier";

export default Tier;
